import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface Props {
  children: ReactNode;
}

export function ProtectedRoute({ children }: Props) {
  const { isAuthenticated, isLoading, currentUser } = useAuth();
  const location = useLocation();

  // While the session is being confirmed, a stored user that the token was
  // issued to (AuthContext seeds it, lib/session checks it) is enough to draw
  // the page: the server still answers every request, and a revoked token's
  // 401 sends this tab to /login. Without one, wait as before.
  if (isLoading && !currentUser) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
